class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    const approved =
      this.dataset.wholesaleApproved === 'true';

    if (!approved) {
      // Keep product details and prices out of the popup.
      const productContainer = this.querySelector(
        '#cart-notification-product'
      );

      if (productContainer) {
        productContainer.replaceChildren();
      }

      // Preserve the login/application buttons.
      // Skip cart icon updates that could include prices.
      this.header?.reveal();
      this.open();
      return;
    }

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const html = parsedState.sections?.[section.id];

      if (!target || typeof html !== 'string') return;

      const source = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(section.selector || '.shopify-section');

      if (source) {
        target.innerHTML = source.innerHTML;
      }
    });

    this.header?.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
